import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Schema } from './create/components/referee-license-form.schema';
import { keys } from './queries';
import { SSF } from '~/apis/api';

export function useCreateRefereeLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ judge, ...payload }: { judge: number } & Schema) => {
      return await SSF.api.judgeLicensesCreate({
        ...payload,
        club: payload.club[1],
        judge,
      });
    },
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: keys.lists(),
      });
    },
  });
}

export function useUpdateRefereeLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, judge, ...payload }: { id: number; judge: number } & Schema) => {
      return await SSF.api.judgeLicensesUpdate(id, {
        ...payload,
        club: payload.club[1],
        judge,
      });
    },
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteRefereeLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.judgeLicensesDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
